//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BdOrderList',
  $dictKeyList: [
    {
      key: 'bdOrderStatus',
      name: '北斗订单状态',
    },
  ],
  data() {
    return {
      filterForm: {
        dateRange: [],
        orderNumber: '', // 订单编号
        statusFlag: '', // 订单状态
        cooperativeName: '', // 采购合作社名称
        title: '', // 北斗终端类型
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0,
        loading: false,
      },
      tableData: [],
      dicts: {
        bdTerminalType: [], // 产品
      }, // 字典数据
      proTotalList: [], // 产品统计列表
    }
  },
  mounted() {
    this.getDicts()
    this.getOrderTotal()
    this.getBdOrderList()
  },
  methods: {
    /**
     * @description: 获取字典
     * @Author: quwandong
     * @Date: 2022-05-17 19:35:48
     */
    async getDicts() {
      try {
        const productRes = await this.$http.bdOrder.getProductList()
        this.dicts.bdTerminalType = [
          {
            label: '全部',
            value: 0,
          },
          ...productRes.data.map((item) => ({
            label: item,
            value: item,
          })),
        ]
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @description: 获取统计详情
     * @Author: quwandong
     * @Date: 2022-05-17 18:56:34
     */
    async getOrderTotal() {
      try {
        const res = await this.$http.bdOrder.getStatistics({
          masterId: this.$route.query.$businessAccountId,
        })
        this.proTotalList = res.data
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @description: 获取北斗订单列表
     * @Author: quwandong
     * @Date: 2022-05-17 14:08:47
     */
    async getBdOrderList() {
      try {
        this.pagination.loading = true
        const [startTime, endTime] = this.filterForm.dateRange
        const { orderNumber, title, statusFlag, cooperativeName } =
          this.filterForm
        let params = {
          startTime,
          endTime,
          currentPage: this.pagination.page,
          pageSize: this.pagination.size,
          masterId: this.$route.query.$businessAccountId,
        }

        title && (params.title = title)
        statusFlag && (params.statusFlag = statusFlag)
        orderNumber && (params.orderNumber = orderNumber)
        cooperativeName && (params.cooperativeName = cooperativeName)

        const res = await this.$http.bdOrder.getOrderlist(params)
        this.tableData = res.data.content.map((item) => {
          return {
            ...item,
            shopTitle: item.productList
              ? item.productList.map(({ title }) => title).join(',')
              : '',
          }
        })
        if (this.pagination.page == 1) {
          this.pagination.total = res.data.recordTotal
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.pagination.loading = false
      }
    },
    /**
     * @description: 条件查询
     * @Author: quwandong
     * @Date: 2022-05-17 14:05:07
     */
    handleFilter() {
      this.pagination.page = 1
      this.getBdOrderList()
    },
    /**
     * @description: 重置查询表单
     * @param formName
     * @Author: quwandong
     * @Date: 2022-05-17 14:05:27
     */
    handleReset() {
      this.filterForm.dateRange = []
      this.filterForm.orderNumber = ''
      this.filterForm.statusFlag = ''
      this.filterForm.title = ''
      this.filterForm.cooperativeName = ''
      this.$nextTick(() => {
        this.handleFilter()
      })
    },
    /**
     * @description: 点击分页
     * @Author: quwandong
     * @Date: 2022-05-17 14:05:53
     */
    handleCurrentChange(val) {
      this.pagination.page = val
      this.getBdOrderList()
    },
    /**
     * @description: 跳转详情页面
     * @param id
     * @Author: quwandong
     * @Date: 2022-05-17 14:24:25
     */
    goDetail(id) {
      this.$router.push({
        path: '/cooperative/bdOrder/detail',
        query: { id },
      })
    },
    /**
     * @description: 状态转换 key 转 text
     * @param value 要转换的值
     * @Author: quwandong
     * @Date: 2022-05-17 19:59:54
     */
    statusFilter(row) {
      const value = row.statusFlag
      if (!value) return ''

      console.log(this.uniqeGlobalDict$$.bdOrderStatus, value)

      const target = this.uniqeGlobalDict$$.bdOrderStatus.find(
        (item) => item.code == value
      )

      return target ? target.name : ''
    },
    /**
     * @description: 获取统计列表的图标class
     * @param undefined
     * @Author: quwandong
     * @Date: 2022-05-17 20:25:43
     */
    getIconClassByCategory(category) {
      if (category === '定位终端') {
        return 'first'
      }

      if (category === '作业监控终端') {
        return 'second'
      }

      if (category === '自动驾驶终端') {
        return 'third'
      }

      if (category === '通讯服务费') {
        return 'fourth'
      }

      return 'first'
    },
  },
}
